import { StyleSheet } from 'react-native'
import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  lastCardContainerStyle: {
    marginRight: 16,
  },
  flatListStyle: {
    paddingHorizontal: 16,
    height: '100%',
    flexGrow: 1,
  },
  appointmentCard: {
    marginBottom: 0,
  },
  container: {
    flexGrow: 1
  },
  contentContainerStyle: {
    paddingBottom: 160,
    paddingTop: 30
  },
  title: {
    ...Fonts.type.bold,
    fontSize: Fonts.size.h4,
    marginBottom: 20
  }
})
